import { useState } from "react";
import { MessageCircleQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "@/lib/featureFlags";
import { HelpChatDialog } from "./HelpChatDialog";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { useHasActiveAiProvider } from "@/hooks/useHasActiveAiProvider";

// TES-1664: pre-existing help button states; this PR only labels the floating icon trigger.
// fallow-ignore-next-line complexity
export function HelpChatButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { enabled, isLoading } = useFeatureFlag("help-chat", FEATURE_FLAGS["help-chat"] ?? false);
  const { data: hasProvider, isLoading: providerLoading } = useHasActiveAiProvider();

  if (isLoading || providerLoading || !enabled || !hasProvider) return null;

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={() => setOpen(true)}
              size="icon"
              className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full shadow-lg"
              aria-label={t("helpChat.tooltip")}
            >
              <MessageCircleQuestion className="h-6 w-6" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">{t("helpChat.tooltip")}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <HelpChatDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
